<template>
    <div class="support">
        <ion-header>
            <ion-toolbar>
                <ion-title>{{ $t('components.support.title') }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button @click="dismiss" slot="icon-only"><ion-icon name="close-circle-outline"></ion-icon></ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content>
            <transition name="collapse-fade" mode="out-in">
                <div class="content-message collapsible" v-if="sent">
                    <ion-item lines="none">
                        <ion-label>&nbsp;</ion-label>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label>{{ $t('components.support.message-sent') }}</ion-label>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label>{{ $t('components.support.in-touch') }}</ion-label>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label>{{ $t('components.support.thanks-for') }}</ion-label>
                    </ion-item>
                </div>
                <div class="content-message collapsible" text-center v-else-if="!sent && sending">
                    <ion-item lines="none" text-center>
                        <ion-spinner name="dots"></ion-spinner>
                    </ion-item>
                    <ion-item lines="none" text-center>
                        <ion-label>{{ $t('components.support.sending') }}</ion-label>
                    </ion-item>
                </div>
                <div class="collapsible" text-center v-else scroll-y="false">
                    <ion-label class="msg">{{ $t('components.support.subtitle') }}</ion-label>
                    <ion-item lines="none" text-left>
                        <ion-textarea ref="message" :placeholder="$t('components.support.placeholder')"></ion-textarea>
                    </ion-item>
                    <ion-item lines="none" v-if="error">
                        <ion-label color="danger" class="error">{{error}}</ion-label>
                    </ion-item>
                    <ion-button @click="commitSupportRequest">{{ $t('components.support.send') }}</ion-button>
                </div>
            </transition>
        </ion-content>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "Support",
        data() {
            return {
                user: this.$store.state.user,
                sending: false,
                error: false,
                sent: false
            };
        },
        methods: {
            dismiss: function() {
                this.$parent.$emit('dismissModal');
            },
            commitSupportRequest: function() {
                if (this.$refs.message.value == '') {
                    this.error = this.$t('components.support.error-empty');
                } else {
                    this.sending = true;
                    axios.post(process.env.VUE_APP_API_FEED_BASE + '/support',
                        {
                            message: this.$refs.message.value
                        },
                        {
                            headers:
                                {
                                    Authorization: `Bearer ${this.user.signInUserSession.getIdToken().getJwtToken()}`
                                }
                        }
                    ).then(response => {
                        this.sending = false;
                        this.error = false;
                        this.sent = true;
                        setTimeout(() => {
                            this.$parent.$emit('dismissModal');
                        }, 3000);
                        this.$logger.debug('DATA', response);
                    }).catch((err) => {
                        this.sending = false;
                        this.$logger.error(err);
                    });
                }
            },
        }
    }
</script>

<style scoped>
.support ion-title, .support ion-content, .support ion-label, .support ion-textarea {
    font-family: 'Nunito', sans-serif !important;
}

ion-textarea {
    background-color: #eee;
    min-height: 8em;
    padding: 0 .5em;
    margin-top: 1em;
    font-size: .8em;
}

ion-icon {
    font-size: 1.8em;
    color: #999;
}

ion-spinner {
    margin: 2em auto;
}

.support ion-title {
    font-weight: bold;
}

.support ion-label.msg {
    color: #666;
    display: block;
    margin-top: 1em;
}

.content-message ion-label {
    color: #666;
}

ion-label.error {
    font-size: .8em;
    margin: 0;
}

.support ion-item {
    --min-height: 1em !important;
}

.support ion-content ion-button {
    margin-top: 1em !important;
}

.collapsible {
    max-height: 20em;
    overflow: hidden;
}
</style>